import {$authHost, $host} from "./index";
import {API_ENDPOINTS, URLS} from "../utils/urls";
import {HistoryFilterParams} from "./actionHistoryAPI";


function buildQuery(params?: HistoryFilterParams): string {
    const query = new URLSearchParams();
    if (params) {
        if (params.limit !== undefined) query.append('limit', `${params.limit}`);
        if (params.offset !== undefined) query.append('offset', `${params.offset}`);
        if (params.userId) query.append('userId', `${params.userId}`);
        if (params.dateFrom) query.append('dateFrom', params.dateFrom);
        if (params.dateTo) query.append('dateTo', params.dateTo);
    }
    const str = query.toString();
    return str ? `?${str}` : '';
}


export async function suppHistoryGetAPI(id: number | string | undefined, params?: HistoryFilterParams){
    try {
        if (id) {
            return await $authHost.get(API_ENDPOINTS.SUPPLIER_HISTORY + `/${id}` + buildQuery(params));
        }

    } catch (error: any) {
        return error;
    }
}
